<script>

    export let title = ''
    export let subtitle = ''

</script>

<section class="section">
    <div class="title">{title}</div>
    <div class="subtitle">{subtitle}</div>
</section>
